import React, { FC, useEffect, useState } from 'react';
import { Select, MenuItem } from '@mui/material';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const getCheckOperatorFromStorage = () => {
    try {
        const raw = localStorage.getItem('checkOperator');
        return raw ? JSON.parse(raw) : {};
    } catch {
        return {};
    }
};

export const SCUIStoreSelect: FC = () => {
    const [storeCode, setStoreCode] = useState(localStorage.getItem('storeCode'));
    const [storeCodeList, setStoreCodeList] = useState<any>();
    const [storeCodeArray, setStoreCodeArray] = useState<any>([]);
    const checkOperatorFromRedux = useSelector((state: any) => state.checkOperatorInfo);

    useEffect(() => {
        const checkOperatorInfo =
            checkOperatorFromRedux && Object.keys(checkOperatorFromRedux).length > 0
                ? checkOperatorFromRedux
                : getCheckOperatorFromStorage();

        if (checkOperatorInfo && Object.keys(checkOperatorInfo).length > 0) {
            setStoreCodeList(checkOperatorInfo.storeCode || '');
            localStorage.setItem('isStoreEmployee', checkOperatorInfo.isStoreEmployee);
        }
    }, [checkOperatorFromRedux]);

    const { t } = useTranslation();

    // Helper function to parse store codes
    const parseStoreCodes = (storeCodeList: string) => {
        return storeCodeList
            .split(',')
            .map((code: string) => code.trim())
            .filter((code: string) => code !== '');
    };

    // Helper function to update store code and localStorage
    const updateStoreCode = (code: string) => {
        setStoreCode(code);
        localStorage.setItem('storeCode', code);
    };

    // Helper function to clear store code
    const clearStoreCode = () => {
        setStoreCode('');
        localStorage.setItem('storeCode', '');
    };

    useEffect(() => {
        if (!storeCodeList) {
            clearStoreCode();
            return;
        }

        const storeArray = parseStoreCodes(storeCodeList);
        setStoreCodeArray(storeArray);

        if (storeArray?.length === 0) {
            clearStoreCode();
            return;
        }

        const localStorageValue = localStorage.getItem('storeCode');
        const matchingItem = localStorageValue
            ? storeArray?.find((item: string) => item === localStorageValue?.trim())
            : null;

        const selectedCode = matchingItem || storeArray?.[0];
        updateStoreCode(selectedCode);
    }, [storeCodeList]);

    const handleChange = (e: any) => {
        setStoreCode(e.target.value);
        localStorage.setItem('storeCode', e.target.value.trim());
        window.location.reload();
    };
    useEffect(() => {
        localStorage.setItem('storeCode', storeCode?.toString().trim() || '');
    }, [storeCode]);

    return storeCodeArray && storeCodeArray.length > 0 ? (
        <div className="sideBySideDiv">
            <div className="regionSelect" style={{ marginTop: '1rem' }}>
                {t('general.storeCode')}:
            </div>
            <Select
                variant="standard"
                value={storeCode}
                onChange={handleChange}
                disableUnderline
                style={{ marginTop: '0.5rem' }}
            >
                {storeCodeArray &&
                    storeCodeArray.map((option: any, index: any) => (
                        <MenuItem key={index} value={option}>
                            {option}
                        </MenuItem>
                    ))}
            </Select>
        </div>
    ) : (
        <React.Fragment />
    );
};
